import { render, staticRenderFns } from "./scroll-container.vue?vue&type=template&id=e98a8052&scoped=true&"
import script from "./scroll-container.vue?vue&type=script&lang=js&"
export * from "./scroll-container.vue?vue&type=script&lang=js&"
import style0 from "./scroll-container.vue?vue&type=style&index=0&id=e98a8052&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98a8052",
  null
  
)

export default component.exports